import settings from '@/settings'

const categoria = (headers, data) => {
    let url = `${settings.apetrusApi}/categorias/`

    if (data.id) {
        url += `${data.id}/`
    }

    let parameter = {
        method: data.method,
        mode: 'cors',
        headers: headers
    }

    if (data.method === 'GET') {
        parameter.cache = 'default'
        if (data.parameters) {
            Object.keys(data.parameters).forEach((filter) => {
                url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parameters[filter]}`
            })
        }
    } else if (data.body) parameter.body = JSON.stringify(data.body)

    return fetch(url, parameter)
}

export default {
    categoria
}
